<template>
  <LazyHydrate never>
    <slot />
  </LazyHydrate>
</template>
<script>
import LazyHydrate from 'vue-lazy-hydration';
export default {
  components: { LazyHydrate },
};
</script>
